import React from "react";
import PropTypes from "prop-types";
import { useStylesReports } from "../../utils/mantine/useStylesReports";
import { Box, Text } from "@mantine/core";
import CustomTooltip from "../mantineCustomComponents/CustomTooltip";
import { useStylesTooltip } from "../../utils/mantine/useStylesTooltip";

const ReportBlock = ({ background, color, title, number, text }) => {
  const { classes: tooltipClasses } = useStylesTooltip();
  const { classes: reportsClasses } = useStylesReports();
  return (
    <Box
      className={reportsClasses.reportsBlockContent}
      style={{ backgroundColor: background, color: color }}
    >
      <Text component="b">{title}</Text>
      <Text
        className={reportsClasses.reportsBlockContentNumber}
        component="span"
      >
        {number}
      </Text>
      {text && (
        <Box className={reportsClasses.reportsBlockContentTooltip}>
          <CustomTooltip
            content={
              <>
                <Text
                  classNames={{
                    root: tooltipClasses.tooltipText,
                  }}
                >
                  {text}
                </Text>
              </>
            }
          ></CustomTooltip>
        </Box>
      )}
    </Box>
  );
};

ReportBlock.propTypes = {
  background: PropTypes.string,
  color: PropTypes.string,
  text: PropTypes.string,
  number: PropTypes.string,
  title: PropTypes.string,
};
export default ReportBlock;
